export const LOCATIONS_RESET_STATE = 'LOCATIONS_RESET_STATE';
export const LOCATIONS_CURRENT_ITEM = 'LOCATIONS_CURRENT_ITEM';

export const LOCATIONS_REQUEST_LOADING = 'LOCATIONS_REQUEST_LOADING';
export const LOCATIONS_REQUEST_SUCCESS = 'LOCATIONS_REQUEST_SUCCESS';
export const LOCATIONS_REQUEST_FAILED = 'LOCATIONS_REQUEST_FAILED';

export const LOCATIONS_CURRENT_ACTION = 'LOCATIONS_CURRENT_ACTION';
export const LOCATIONS_RESET_ACTION = 'LOCATIONS_RESET_ACTION';